import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const VariantsFilterContentWrapper = styled.div`
  span {
    ${theme.typography.labelRegular400}
  }
`;
